import { lazy } from 'react';

import { PageSuspense } from 'src/components';


const AccountProductShortUpdatePage = lazy(() => import('../views/update/AccountProductShortUpdatePage'));

export function AccountProductShortUpdatePageLazy() {
	return (
		<PageSuspense>
			<AccountProductShortUpdatePage />
		</PageSuspense>
	);
}
